import { observable, action, runInAction } from "mobx";

export default class ReasignProjectOwnerStore {

  constructor(http, projectOwnerStore, maintenanceAgencyStore) {
    this.http = http;
    this.projectOwnerStore = projectOwnerStore;
    this.maintenanceAgencyStore = maintenanceAgencyStore;
  }

  @observable
  jsonToSend_AssignProjectPrivileges = {
    actionType: "ReassignProjectOwnership",
    pid: "",
    aids: "",
    role: "OWNER"
  };

  @action("Assing/Reasign PO to selected Project")
  reapo_action_create_AssignPO = (selected_pOwners, obj_selected_project) => {
    try {
      const { project: { tid } } = obj_selected_project;

      if (
        selected_pOwners.constructor === Array &&
        selected_pOwners.length > 0
      ) {
        const a_map_pos_toNumber = selected_pOwners.map(item =>
          Number(item.value)
        );

        this.jsonToSend_AssignProjectPrivileges = {
          actionType: "ReassignProjectOwnership",
          pid: tid,
          aids: a_map_pos_toNumber,
          role: "OWNER"
        };
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  @action("reapo_action_assignPo_httpReq")
  reapo_action_assignPo_httpReq = () => {
    runInAction(() => {
      this.http.func_sendGeneralMessage(
        this.jsonToSend_AssignProjectPrivileges, response => {
        }
      );
    });
  };
}
